<template>
  <div>
    <div class="page_title">
      {{$i18n.t("releaseMsg.text74")}}

      <el-select
        v-model="selectedPid"
        size="mini"
        @change="productChange"
        style="margin-left: 10px;"
        :placeholder="$i18n.t('releaseMsg.text75')">
        <el-option
          v-for="item in productList"
          :key="item.pid"
          :label="item.name"
          :value="item.pid">
        </el-option>
      </el-select>
    </div>

    <div class="panel">
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="panel_top">
            <div class="panel_top_header">
              <span class="panel_top_title">{{$i18n.t('releaseMsg.text77')}}</span>
              <span class="panel_top_update_time">{{$i18n.t('releaseMsg.text78')}}：{{deviceStatistic.modifyTime}}</span>
            </div>
            <el-row :gutter="24" style="margin-top: 24px">
              <el-col :span="12">
                <div class="card card1">
                  <div class="card_label">
                    <span>{{$i18n.t('releaseMsg.text79')}}</span>
                    <el-popover
                      placement="top-start"
                      title=""
                      width="200"
                      trigger="hover"
                      :content="$i18n.t('releaseMsg.text80')">
                      <i
                        :class="card1Icon"
                        style="margin-left: 5px;"
                        @mouseover="card1Icon = 'panel_question_coicon icon-yiwen'"
                        @mouseleave="card1Icon = 'panel_question_alicon iconfont_al icon-yiwen'"
                        slot="reference"></i>
                    </el-popover>
                  </div>
                  <span class="card_value">{{deviceStatistic.onlineAmount}}</span>
                  <div style="position: absolute;right: -24px;bottom: -36px;">
                    <svg width="106.863037" height="105.389465" viewBox="0 0 106.863 105.389" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <desc>
                        Created with Pixso.
                      </desc>
                      <defs/>
                      <path id="path" d="M62.17 1.89L2.7 43.53C1.21 44.57 0.85 46.65 1.9 48.15L34.35 94.48C35.4 95.98 37.47 96.36 38.96 95.31L98.43 53.67C99.92 52.63 100.27 50.55 99.22 49.05L66.78 2.72C65.73 1.22 63.66 0.85 62.17 1.89ZM91.91 50.12L37.85 87.97L9.22 47.09L63.28 9.23L91.91 50.12ZM90.88 63.02L50.33 91.42L54.15 96.87L94.69 68.47L90.88 63.02Z" fill="#FFFFFF" fill-opacity="1.000000" fill-rule="nonzero"/>
                      <path id="path" d="M56.15 61.75C56.82 61.28 57.17 60.63 57.43 59.84L64.91 32.26L58.43 30.5L51.7 55.12L36.94 52.45L35.83 58.92L53.49 61.99C54.6 62.43 55.47 62.23 56.15 61.75Z" fill="#FFFFFF" fill-opacity="1.000000" fill-rule="nonzero"/>
                    </svg>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="card card2">
                  <div class="card_label">
                    <span>{{$i18n.t('releaseMsg.text81')}}</span>
                    <el-popover
                      placement="top-start"
                      title=""
                      width="200"
                      trigger="hover"
                      :content="$i18n.t('releaseMsg.text82')">
                      <i
                        :class="card2Icon"
                        style="margin-left: 5px;"
                        @mouseover="card2Icon = 'panel_question_coicon icon-yiwen'"
                        @mouseleave="card2Icon = 'panel_question_alicon iconfont_al icon-yiwen'"
                        slot="reference"></i>
                    </el-popover>
                  </div>
                  <span class="card_value">{{deviceStatistic.totalAmount - deviceStatistic.onlineAmount}}</span>
                  <div style="position: absolute;right: -24px;bottom: -36px;">
                    <svg width="106.863037" height="105.389465" viewBox="0 0 106.863 105.389" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <desc>
                        Created with Pixso.
                      </desc>
                      <defs/>
                      <path id="path" d="M62.17 1.89L2.7 43.53C1.21 44.57 0.85 46.65 1.9 48.15L34.35 94.48C35.4 95.98 37.47 96.36 38.96 95.32L98.43 53.67C99.92 52.63 100.27 50.55 99.22 49.05L66.78 2.72C65.73 1.22 63.66 0.85 62.17 1.89ZM91.91 50.12L37.85 87.97L9.22 47.09L63.28 9.23L91.91 50.12ZM90.88 63.02L50.33 91.42L54.15 96.87L94.69 68.47L90.88 63.02Z" fill="#FFFFFF" fill-opacity="1.000000" fill-rule="nonzero"/>
                      <path id="path" d="M37.69 45.51L66.74 50.76" stroke="#FFFFFF" stroke-opacity="1.000000" stroke-width="5.559532" stroke-linejoin="round"/>
                      <path id="path" d="M49.71 62.69L54.72 33.59" stroke="#FFFFFF" stroke-opacity="1.000000" stroke-width="5.559532" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-top: 24px">
              <el-col :span="12">
                <div class="card card3">
                  <div class="card_label">
                    <span>{{$i18n.t('releaseMsg.text83')}}</span>
                  </div>
                  <span class="card_value">{{deviceStatistic.totalAmount}}</span>
                  <div style="position: absolute;right: -24px;bottom: -36px;">
                    <svg width="106.863037" height="105.389465" viewBox="0 0 106.863 105.389" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <desc>
                        Created with Pixso.
                      </desc>
                      <defs/>
                      <path id="path" d="M62.17 1.89L2.7 43.53C1.21 44.57 0.85 46.65 1.9 48.15L34.35 94.48C35.4 95.98 37.47 96.36 38.96 95.32L98.43 53.67C99.92 52.63 100.27 50.55 99.22 49.05L66.78 2.72C65.73 1.22 63.66 0.85 62.17 1.89ZM91.91 50.11L37.85 87.97L9.22 47.09L63.28 9.23L91.91 50.11ZM90.88 63.02L50.33 91.42L54.15 96.87L94.69 68.47L90.88 63.02Z" fill="#FFFFFF" fill-opacity="1.000000" fill-rule="nonzero"/>
                      <path id="path" d="M55.85 61.79L61.15 58.08L46.19 36.72L40.89 40.43L55.85 61.79ZM44.12 70.01L49.42 66.3L41.94 55.62L36.64 59.33L44.12 70.01ZM57.3 38.89L67.59 53.58L72.88 49.87L62.6 35.18L57.3 38.89Z" fill="#FFFFFF" fill-opacity="1.000000" fill-rule="nonzero"/>
                    </svg>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="card card4">
                  <div class="card_label">
                    <span>{{$i18n.t('releaseMsg.text84')}}</span>
                  </div>
                  <span class="card_value">{{deviceStatistic.totalAmount > 0 ? (deviceStatistic.onlineAmount/deviceStatistic.totalAmount * 100).toFixed(2) : 0}}%</span>
                  <div style="position: absolute;right: -24px;bottom: -36px;">
                    <svg width="106.863037" height="105.389465" viewBox="0 0 106.863 105.389" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <desc>
                        Created with Pixso.
                      </desc>
                      <defs/>
                      <path id="path" d="M62.17 1.89L2.7 43.53C1.21 44.57 0.85 46.65 1.9 48.15L34.35 94.48C35.4 95.98 37.47 96.36 38.96 95.32L98.43 53.67C99.92 52.63 100.27 50.55 99.22 49.05L66.78 2.72C65.73 1.22 63.66 0.85 62.17 1.89ZM91.91 50.11L37.85 87.97L9.22 47.09L63.28 9.23L91.91 50.11ZM90.88 63.02L50.33 91.42L54.15 96.87L94.69 68.47L90.88 63.02Z" fill="#FFFFFF" fill-opacity="1.000000" fill-rule="nonzero"/>
                      <ellipse id="circle" rx="6.699018" ry="6.754381" transform="matrix(0.819152 -0.573576 0.573576 0.819152 35.0532 45.376)" stroke="#FFFFFF" stroke-opacity="1.000000" stroke-width="4.632944" stroke-linejoin="round"/>
                      <ellipse id="circle" rx="6.699018" ry="6.754381" transform="matrix(0.819152 -0.573576 0.573576 0.819152 66.178 50.9961)" stroke="#FFFFFF" stroke-opacity="1.000000" stroke-width="4.632944" stroke-linejoin="round"/>
                      <path id="path" d="M46.9 69.76L54.32 26.6" stroke="#FFFFFF" stroke-opacity="1.000000" stroke-width="5.559532" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="panel_top">
            <div class="panel_top_header">
              <span class="panel_top_title">{{$i18n.t('releaseMsg.text85')}}</span>
            </div>
            <div class="chart_card">
              <div id="chart"></div>
              <div class="chart_legend">
                <div class="chart_legend_item" :style="{marginTop: index === 0 ? '' : '16px'}" v-for="(item, index) in firmwareTypeList" :key="item.type">
                  <div class="chart_legend_left">
                    <div class="chart_legend_point" :style="{backgroundColor: item.color}"></div>
                    <span class="chart_legend_label">
                       <el-popover
                         v-if="item.type !== $i18n.t('releaseMsg.text86')"
                         placement="top"
                         title=""
                         width="200"
                         trigger="hover"
                         :content="item.type">
                         <span slot="reference" style="cursor: pointer;">{{item.type.length > 16 ? item.type.slice(0, 16) + '...' + item.type.slice(-5) : item.type}}</span>
                       </el-popover>
                       <el-popover
                         v-else
                         width="320"
                         placement="bottom-start"
                         :offset="-17"
                         trigger="click"
                       >
                         <div style="max-height: 300px;overflow-y: auto;">
                           <div class="chart_legend_item" :style="{marginTop: index1 === 0 ? '' : '16px'}" v-for="(item1, index1) in otherFirmwareTypeList" :key="item1.type">
                             <div class="chart_legend_left">
                               <el-popover
                                 placement="top"
                                 title=""
                                 width="200"
                                 trigger="hover"
                                 :content="item1.type">
                                 <span slot="reference" style="cursor: pointer;">{{item1.type.length > 16 ? item1.type.slice(0, 16) + '...' + item1.type.slice(-5) : item1.type}}</span>
                               </el-popover>
                             </div>
                             <div class="chart_legend_right">
                               <span class="chart_legend_value">{{item1.value}}</span>
                               <el-divider direction="vertical"></el-divider>
                               <div class="chart_legend_percent">{{(item1.value/firmwareTypeSum * 100).toFixed(0)}}%</div>
                             </div>
                           </div>
                         </div>
                         <span slot="reference" style="cursor: pointer;">{{item.type}}<i class="el-icon-arrow-down" style="color: rgb(24, 144, 255);margin-left: 7px;"></i></span>
                       </el-popover>
                    </span>
                  </div>
                  <div class="chart_legend_right">
                    <span class="chart_legend_value">{{item.value}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <div class="chart_legend_percent">{{(item.value/firmwareTypeSum * 100).toFixed(0)}}%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="panel_bottom">
        <div class="panel_bottom_header">
          <span class="panel_bottom_title">{{$i18n.t('releaseMsg.text76')}}</span>
          <el-input
            style="width: 360px;"
            :placeholder="$i18n.t('releaseMsg.text87')"
            clearable
            v-model="otaFileCode">
            <el-select v-model="queryType" style="width: 110px" slot="prepend">
              <el-option :label="$i18n.t('releaseMsg.text88')" :value="1"></el-option>
              <el-option :label="$i18n.t('releaseMsg.text73')" :value="2"></el-option>
            </el-select>
            <el-button slot="append" @click="getTaskPager(1)" icon="el-icon-search"></el-button>
          </el-input>
        </div>
        <el-table
          ref="taskTable"
          class="task_table"
          :data="taskData.list"
          style="width: 100%;margin-top: 16px;"
          :header-cell-style="{background:'#eef1f6',color:'rgba(0, 0, 0 ,.85)', paddingLeft: '24px'}"
          :cell-style="{color:'rgba(0, 0, 0 ,.65)', padding: '6px 24px'}"
          @sort-change="sortChange"
          v-loading="tableLoading">
          <el-table-column
            width="230"
            prop="code"
            :label="$i18n.t('releaseMsg.text88')">
          </el-table-column>
          <el-table-column
            width="250"
            :label="$i18n.t('releaseMsg.text89')">
            <template slot-scope="scope">
              <el-popover
                placement="top"
                title=""
                width="200"
                trigger="hover"
                :content="scope.row.name">
                <span slot="reference" style="cursor: pointer;">
                  {{scope.row.name.length > 16 ? scope.row.name.slice(0, 16) + '...' + scope.row.name.slice(-5) : scope.row.name}}
                </span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            :label="$i18n.t('releaseMsg.text71')">
            <template slot-scope="scope">
              {{scope.row.versionType === 1 ? $i18n.t('releaseMsg.text70') : $i18n.t('releaseMsg.text69')}}
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            prop="upgradeSuccessAmount"
            :label="$i18n.t('releaseMsg.text90')">
          </el-table-column>
          <el-table-column
            width="150"
            prop="totalCount"
            :label="$i18n.t('releaseMsg.text91')">
          </el-table-column>
          <el-table-column
            width="150"
            :label="$i18n.t('releaseMsg.text92')">
            <template slot-scope="scope">
              {{scope.row.totalCount > 0 ? (scope.row.upgradeSuccessAmount/scope.row.totalCount * 100).toFixed(2) : 0}}%
            </template>
          </el-table-column>
          <el-table-column
            width="250"
            sortable="custom"
            prop="startTime"
            :label="$i18n.t('releaseMsg.text93')">
          </el-table-column>
          <el-table-column
            fixed="right"
            width="180"
            :label="$i18n.t('ota.text21')">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="toFirmwareMsg(scope.row)">{{ $i18n.t('releaseMsg.text94') }}</el-button>
              <el-button
                v-if="scope.row.totalCount > scope.row.upgradeSuccessAmount"
                :loading="scope.row.loading"
                type="text"
                size="small"
                style="color: rgb(255, 40, 37);"
                @click="terminateTask(scope.row)"
              >
                {{ $i18n.t('releaseMsg.text95') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="10"
          :current-page="page"
          layout="total, prev, pager, next, jumper"
          style="margin-top: 10px;text-align: right;padding-bottom: 10px;"
          :total="parseInt(taskData.totalRecords)">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {Pie} from '@antv/g2plot';

export default {
  name: "otaPanel",
  data() {
    return {
      productList: [],
      selectedPid: '',
      orderBy: '',
      isAsc: null,
      card1Icon: "panel_question_alicon iconfont_al icon-yiwen",
      card2Icon: "panel_question_alicon iconfont_al icon-yiwen",
      chart: null,
      colors: ['rgb(24, 144, 255)', 'rgb(54, 203, 203)', 'rgb(101, 119, 155)', 'rgb(245, 190, 26)', 'rgb(238, 134, 180)'],
      firmwareTypeList: [],
      firmwareTypeSum: 120,
      otherFirmwareTypeList: [],
      deviceStatistic: {
        modifyTime: "",
        onlineAmount: 0,
        totalAmount: 0
      },
      taskData: {
        list: [],
        totalRecords: 0
      },
      page: 1,
      tableLoading: false,
      otaFileCode: '',
      queryType: 1,
    }
  },
  mounted() {
    this.getProductList();
  },
  methods: {

    ...mapActions('maintain', ['queryProduct', 'queryStatisticByPid', 'queryStatisticByFirmware', 'queryTaskPager', 'createInterruptTask']),

    productChange(value) {
      this.chart.destroy();
      this.selectedPid = value;
      this.getStatisticByPid();
      this.getStatisticByFirmware();
      this.getTaskPager(1);
    },

    setChart() {
      this.chart = new Pie('chart', {
        appendPadding: 10,
        legend: false,
        tooltip: false,
        color: ({type}) => {
          let color = '';
          this.firmwareTypeList.forEach(item => {
            if (item.type === type) {
              color = item.color;
            }
          })
          return color;
        },
        data: this.firmwareTypeList,
        angleField: 'value',
        colorField: 'type',
        radius: 1,
        innerRadius: 0.6,
        label: {
          content: '',
        },
        interactions: [{ type: 'element-selected' }, { type: 'element-active' }],
        statistic: {
          title: false,
          content: {
            content: '',
          },
        },
      })

      this.chart.render();
    },

    sortChange({prop, order}) {
      console.log(prop, order);
      this.orderBy = 'start_time';
      this.isAsc = order === null ? order : order === 'ascending';
      this.getTaskPager();
    },

    terminateTask(row) {
      this.$dialog.showConfirm({
        title: this.$i18n.t('releaseMsg.text96'),
        content: this.$i18n.t('releaseMsg.text97')
      }, () => {
        row.loading = true;
        this.createInterruptTask({
          otaFileCode: row.identifier,
          triggerInstanceCode: row.code
        }).then(() => {
          this.$dialog.showMessage(this.$i18n.t('releaseMsg.text98'), this.$config.TOAST_SUCCESS);
        }, err => {
          console.log(err);
          this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
        }).finally(() => {
          row.loading = false;
        })
      })
    },

    getStatisticByPid() {
      this.queryStatisticByPid({
        pid: this.selectedPid
      }).then(res => {
        this.deviceStatistic = res.result;
      }, err => {
        console.log(err);
        this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
      })
    },

    getStatisticByFirmware() {
      this.queryStatisticByFirmware({
        pid: this.selectedPid,
        currPage: 1,
        pageSize: 100000
      }).then(res => {
        console.log(res)
        const list = [];
        const otherList = [];
        let firmwareTypeSum = 0;
        let otherFirmwareTypeSum = 0;
        res.result.list.forEach((item, index) => {
          firmwareTypeSum += item.totalAmount;
          index < 4 && list.push({
            type: `${item.pid}_${item.firmwareModel}_${item.version}`,
            value: item.totalAmount,
            color: this.colors[index]
          })
          res.result.list.length === 5 && index === 4 && list.push({
            type: `${item.pid}_${item.firmwareModel}_${item.version}`,
            value: item.totalAmount,
            color: this.colors[index]
          })
          res.result.list.length > 5 && index >= 4  && (otherFirmwareTypeSum += item.totalAmount);
          res.result.list.length > 5 && index >= 4 && otherList.push({
            type: `${item.pid}_${item.firmwareModel}_${item.version}`,
            value: item.totalAmount
          })
        })
        res.result.list.length > 5 && list.push({
          type: this.$i18n.t('releaseMsg.text86'),
          value: otherFirmwareTypeSum,
          color: this.colors[4]
        })
        this.firmwareTypeSum = firmwareTypeSum;
        this.firmwareTypeList = list;
        this.otherFirmwareTypeList = otherList;
        this.setChart();
      }, err => {
        console.log(err);
        this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
      })
    },

    toFirmwareMsg(row) {
      this.$router.push({
        path: "/firmwareMsg",
        query: {
          triggerInstanceCode: row.code,
          otaFileCode: row.identifier,
          type: 2
        }
      })
    },

    getTaskPager(page) {
      if (page) this.page = page;
      this.tableLoading = true;
      this.queryTaskPager({
        pid: this.selectedPid,
        currPage: this.page,
        pageSize: 10,
        key: this.otaFileCode,
        queryType: this.queryType,
        orderBy: this.orderBy,
        isAsc: this.isAsc
      }).then(res => {
        res.result.list.forEach(item => {
          item.name = `${item.pid}_${item.firmwareModel}_${item.version}`
          item.loading = false;
        })
        this.taskData = res.result;
      }, err => {
        console.log(err);
        this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
      }).finally(() => {
        this.tableLoading = false;
      })
    },

    handleCurrentChange(page) {
      this.getTaskPager(page);
    },

    getProductList() {
      this.queryProduct({
        currPage: 1,
        pageSize: 100000
      }).then(res => {
        console.log(res)
        this.productList = res.result.list;
        this.productList.length > 0 && (this.selectedPid = this.productList[0].pid);
        this.getStatisticByPid();
        this.getStatisticByFirmware();
        this.getTaskPager();
      }, err => {
        console.log(err);
        this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
      })
    }

  }
}
</script>

<style scoped>

.panel {
  margin: 70px 24px 24px 24px;
  animation: fadeInDown; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */
}

.panel_top {
  height: 280px;
  background: #FFFFFF;
  border-radius: 4px;
  padding: 24px;
}

.panel_top_header {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.panel_top_title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
}

.panel_top_update_time {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  margin-left: 8px;
}

.panel_bottom {
  width: calc(100% - 48px);
  background: #FFFFFF;
  border-radius: 4px;
  margin-top: 24px;
  padding: 24px 24px 0 24px;
}

.card {
  position: relative;
  width: calc(100% - 48px);
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  padding: 0 24px;
}

.card_label {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  z-index: 2;
}

.card_value {
  font-size: 24px;
  font-weight: bold;
  margin-right: 14px;
  z-index: 2;
}

.chart_card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 36px;
}

#chart {
  width: 200px;
  height: 200px;
}

.card1 {
  color: rgb(3, 40, 114);
  background: linear-gradient(to bottom, rgb(226, 237, 255), rgb(249, 251, 255));
}
.card2 {
  color: rgb(171, 48, 48);
  background: linear-gradient(to bottom, rgb(255, 235, 235), rgb(255, 251, 252));
}
.card3 {
  color: rgb(205, 110, 44);
  background: linear-gradient(to bottom, rgb(255, 236, 223), rgb(255, 254, 253));
}
.card4 {
  color: rgb(6, 106, 128);
  background: linear-gradient(to bottom, rgb(221, 245, 255), rgb(247, 253, 255));
}

.panel_question_coicon {
  color: #1890FF;
  font-size: 16px;
  cursor: pointer;
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.panel_question_alicon {
  color: rgba(0, 0, 0, 0.4);
  font-size: 16px;
  cursor: pointer;
}

.chart_legend {
  width: 320px;
  display: flex;
  flex-direction: column;
}

.chart_legend_item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.chart_legend_point {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.chart_legend_label {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  margin-left: 7px;
}

.chart_legend_value {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

.chart_legend_percent {
  width: 33px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

.chart_legend_left, .chart_legend_right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

/deep/ .el-pagination__total {
  float: left;
}

.panel_bottom_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.panel_bottom_title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
}

.page_title {
  z-index: 3;
}

</style>